module.exports = __webpack_public_path__ + "img/header.43bc43a2.png";